export default {
      id: "ic-combined-shape-usage",
      viewBox: "0 0 38 38",
      url: "/" + "images/icons.3.109.2.svg#ic-combined-shape-usage",
      toString: function () {
        return this.url;
      }
    }